"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanInput = void 0;
/**
 * Renders a check box.
 */
const React = require("react");
const ButtonOptionsInput_1 = require("../ButtonOptionsInput");
const BooleanInput = props => (
// @ts-ignore
React.createElement(ButtonOptionsInput_1.ButtonOptionsInput, Object.assign({ options: { Yes: true, No: false } }, props)));
exports.BooleanInput = BooleanInput;
//# sourceMappingURL=index.js.map